module.exports = __webpack_public_path__ + "static/media/last-6-2.05b33c3e.png";